import { useEffect, useRef, useState } from "react";
import "./LiveChat.css";
import { connectRealtime, onRealtime, sendRealtime } from "./realtime";

export default function LiveChat() {
  const [open, setOpen] = useState(false);
  const [online, setOnline] = useState(false);
  const [name, setName] = useState("");
  const [askName, setAskName] = useState(true);
  const [text, setText] = useState("");
  const [msgs, setMsgs] = useState([]);
  const [unread, setUnread] = useState(0);
  const bodyRef = useRef(null);

  useEffect(() => {
    connectRealtime();
    const off = onRealtime((evt) => {
      if (evt.type === "__status") { setOnline(evt.online); return; }
      if (evt.type === "chat") {
        let isDup = false;
        const key = `${evt.at}|${evt.role}|${evt.text}`;
        setMsgs((m) => {
          if (m.some((x) => `${x.at}|${x.role}|${x.text}` === key)) { isDup = true; return m; }
          return [...m, evt];
        });
        if (isDup) return;
        if (!open) setUnread((u) => u + 1);
      }
    });
    return () => off();
  }, [open]);

  useEffect(() => {
    if (bodyRef.current) bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
  }, [msgs, open]);

  // WhatsApp-style tab title badge for unread replies
  useEffect(() => {
    const m = document.title.match(/^\(\d+\)\s*(.*)$/);
    const base = m ? m[1] : document.title;
    document.title = unread > 0 ? `(${unread}) ${base}` : base;
  }, [unread]);

  const startChat = () => {
    if (!name.trim()) return;
    setAskName(false);
    // auto-greeting at the start of every new conversation
    setMsgs([{
      role: "staff",
      from: "OotyGo Team",
      text: `Hi ${name.trim()}! 👋 Welcome to OotyGo. Ask us anything about Ooty packages, cabs or stays — our team will reply right here.`,
      at: new Date().toISOString(),
    }]);
  };

  const send = () => {
    const t = text.trim();
    if (!t) return;
    sendRealtime({ action: "chat", text: t, from: name || "Guest" });
    setText("");
  };

  return (
    <>
      {/* Launcher */}
      <button
        className={`lc-launch ${open ? "hide" : ""}`}
        onClick={() => { setOpen(true); setUnread(0); }}
        aria-label="Live chat"
      >
        💬
        {unread > 0 && <span className="lc-badge">{unread}</span>}
      </button>

      {/* Panel */}
      {open && (
        <div className="lc-panel">
          <div className="lc-head">
            <div>
              <strong>Chat with OotyGo</strong>
              <span className={`lc-dot ${online ? "on" : ""}`} /> {online ? "We're online" : "Connecting…"}
            </div>
            <button className="lc-close" onClick={() => setOpen(false)}>×</button>
          </div>

          <div className="lc-body" ref={bodyRef}>
            {askName ? (
              <div className="lc-name">
                <p>👋 Hi! What's your name?</p>
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Your name"
                  onKeyDown={(e) => e.key === "Enter" && startChat()}
                />
                <button disabled={!name.trim()} onClick={startChat}>Start chatting</button>
              </div>
            ) : msgs.length === 0 ? (
              <p className="lc-hint">Say hi 👋 — our Ooty travel team will reply here.</p>
            ) : (
              msgs.map((m, i) => (
                <div key={i} className={`lc-msg ${m.role === "staff" ? "them" : "me"}`}>
                  {m.role === "staff" && <span className="lc-from">{m.from}</span>}
                  <span className="lc-bubble">{m.text}</span>
                </div>
              ))
            )}
          </div>

          {!askName && (
            <div className="lc-input">
              <input
                value={text}
                onChange={(e) => setText(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && send()}
                placeholder="Type a message…"
              />
              <button onClick={send}>➤</button>
            </div>
          )}
        </div>
      )}
    </>
  );
}
